module.exports = __webpack_public_path__ + "f2fff221e334f335f9de0c759109efd6.MP3";